import './index.css'

const ClosedNotice = () => {
	return (
		<div className="outer">
			<div className="container">
				<div className="plate"></div>
				<div className="message">Restaurant Closed</div>
				<div className="sub-message">No orders being accepted right now</div>
			</div>
		</div>
	);
};

export default ClosedNotice;
